import React from 'react';
import { HistoryIcon } from 'lucide-react';
import { CalcHistoryEntry } from '../../types/commission';
import { Card } from '../sf/Card';
import { ExampleDataBadge } from '../sf/ExampleDataBadge';
import { NewBadge } from '../sf/NewBadge';
export function CalculationHistory({
  entries
}: {
  entries: CalcHistoryEntry[];
}) {
  return <Card title="History" icon={HistoryIcon} iconBg="#706E6B" meta="Nightly recalculation replaces lines in place while October is open. Base stays fixed for the quarter." actions={<>
          <NewBadge label="NEW · nightly recalculation" data-id="element-490" data-mp="3q2r1n8b7iguc" />
          <ExampleDataBadge data-id="element-491" data-mp="3m1njgf5os8py" />
        </>} data-id="element-489" data-mp="2yeyzzp114878">
      <ol data-id="element-492" data-mp="3h3vtvrsikyox">
        {entries.map((entry, index) => <li key={entry.id} className="flex gap-3" data-id="element-493" data-mp="3h3doo5nvja4v" data-mpi={index}>
            <div className="flex flex-col items-center pt-1.5" data-id="element-494" data-mp="2anjph8z3mkkw">
              <span className={`h-2 w-2 shrink-0 rounded-full ${index === 0 ? 'bg-sf-blue' : 'bg-sf-border-strong'}`} aria-hidden="true" data-id="element-495" data-mp="2alqlk1fveegl" />
              {index < entries.length - 1 && <span className="mt-1 w-px flex-1 bg-sf-border" aria-hidden="true" data-id="element-496" data-mp="3szfqt7xe1ntk" />}
            </div>
            <div className="grid flex-1 grid-cols-[110px_minmax(0,1fr)] gap-3 pb-3" data-id="element-497" data-mp="1qjvp8ybnbf1">
              <p className="text-xs tabular-nums text-sf-weak" data-id="element-498" data-mp="3jwentg3tkcu4">{entry.timestamp}</p>
              <div data-id="element-499" data-mp="3ow18galz8vcy">
                <p className="text-[13px] font-semibold" data-id="element-500" data-mp="3ov81p9n0q5ut">{entry.title}</p>
                <p className="text-xs text-sf-weak" data-id="element-501" data-mp="3a74tdtli6i2u">{entry.detail}</p>
              </div>
            </div>
          </li>)}
      </ol>
    </Card>;
}